// Set a feature to true to expose its existing frontend entry points again.
const FRONTEND_FEATURES = Object.freeze({
  faceRecognition: false,
  liveness: false,
});

const isFeatureEnabled = (featureName) => FRONTEND_FEATURES[featureName] === true;

const FACE_RECOGNITION_TRAINING_MODEL_TYPES = new Set(["fr", "fr_arcface"]);
const LIVENESS_TRAINING_MODEL_TYPES = new Set(["liveness"]);

const normalizeModelType = (modelType) =>
  String(modelType || "").trim().toLowerCase();

const isHiddenTrainingModelType = (modelType) => {
  const normalizedModelType = normalizeModelType(modelType);
  return (
    (!isFeatureEnabled("faceRecognition") &&
      FACE_RECOGNITION_TRAINING_MODEL_TYPES.has(normalizedModelType)) ||
    (!isFeatureEnabled("liveness") &&
      LIVENESS_TRAINING_MODEL_TYPES.has(normalizedModelType))
  );
};

const isVisibleTrainingModelType = (modelType) =>
  !isHiddenTrainingModelType(modelType);

const isVisibleTrainedModel = (model) => {
  const modelType = model?.model_type;
  const orgType = model?.org_type;
  return isVisibleTrainingModelType(modelType) && isVisibleTrainingModelType(orgType);
};

const FACE_RECOGNITION_AUTODAG_NAME_PATTERNS = [
  /(^|[/_+\-\s])fr([/_+\-\s]|\d|only|v|$)/i,
  /(^|[/_+\-\s])fronly/i,
  /(^|[/_+\-\s])(face|facial|retinaface|yolov5_face)/i,
];

const LIVENESS_AUTODAG_NAME_PATTERNS = [
  /liveness/i,
  /anti[_+\-\s]?spoof/i,
  /registration_flow/i,
  /fas[_+\-\s]?model/i,
];

const isVisibleAutoDagName = (name) => {
  const dagName = String(name || "");
  return (
    (isFeatureEnabled("faceRecognition") ||
      !FACE_RECOGNITION_AUTODAG_NAME_PATTERNS.some((pattern) => pattern.test(dagName))) &&
    (isFeatureEnabled("liveness") ||
      !LIVENESS_AUTODAG_NAME_PATTERNS.some((pattern) => pattern.test(dagName)))
  );
};

const filterVisibleAutoDagNames = (autodagNames) =>
  Object.fromEntries(
    Object.entries(autodagNames || {}).filter(([name]) => isVisibleAutoDagName(name))
  );

export {
  FRONTEND_FEATURES,
  filterVisibleAutoDagNames,
  isFeatureEnabled,
  isHiddenTrainingModelType,
  isVisibleAutoDagName,
  isVisibleTrainingModelType,
  isVisibleTrainedModel,
};
